import { onMounted } from 'vue';
import { usePageStore } from '@/page/infrastructure/composition/usePageStore';
import { loadChatAppWidget, shouldShowWidget } from '@/page/domain/ChatApp';
import { viewportSize } from '@hfc/ui-core';

export const useChatApp = (): void => {
  const { pageStore } = usePageStore();

  const { viewport } = viewportSize();

  onMounted(() => {
    pageStore.onGlobalSettingsLoaded(() => {
      if (shouldShowWidget({
        chatApp: pageStore.state.globalSettings?.chatApp,
        isMobile: viewport.value.isMobile
      })) {
        loadChatAppWidget();
      }
    });
  });
};
